export default __webpack_public_path__ + "static/media/no-history-img.c1e6ff7d.svg";